import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Play, TrendingUp, Shield, Zap } from 'lucide-react';
import './Hero.scss';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero__background">
        <div className="hero__gradient"></div>
        <div className="hero__particles"></div>
      </div>
      
      <div className="container">
        <div className="hero__content">
          {/* Main Content */}
          <div className="hero__main">
            <div className="hero__badge">
              <Zap size={16} />
              <span>AI Trading Bot + AI-Assisted Trading Platform</span>
            </div>
            
            <h1 className="hero__title">
              Automated & Assisted
              <span className="gradient-text"> AI Trading Solutions</span>
            </h1>
            
            <p className="hero__subtitle">
              CoinVAT combines fully automated AI trading bots with intelligent trading assistance. 
              Whether you prefer hands-off automation or AI-enhanced manual trading, our platform 
              delivers institutional-grade tools and security for every trading style.
            </p>
            
            <div className="hero__stats">
              <div className="hero__stat">
                <div className="hero__stat-number">$2.4B+</div>
                <div className="hero__stat-label">Trading Volume</div>
              </div>
              <div className="hero__stat">
                <div className="hero__stat-number">99.9%</div>
                <div className="hero__stat-label">Uptime</div>
              </div>
              <div className="hero__stat">
                <div className="hero__stat-number">10,000+</div>
                <div className="hero__stat-label">Active Traders</div>
              </div>
            </div>
            
            <div className="hero__actions">
              <Link to="/signup" className="btn btn-primary btn-lg">
                Start Trading Now
                <ArrowRight size={20} />
              </Link>
              <button className="hero__demo-btn">
                <div className="hero__demo-icon">
                  <Play size={16} />
                </div>
                <span>Watch Demo</span>
              </button>
            </div>
            
            <div className="hero__features">
              <div className="hero__feature">
                <TrendingUp size={20} />
                <span>Automated AI Trading</span>
              </div>
              <div className="hero__feature">
                <Shield size={20} />
                <span>AI Trading Assistant</span>
              </div>
              <div className="hero__feature">
                <Zap size={20} />
                <span>Lightning Fast Execution</span>
              </div>
            </div>
          </div>
          
          {/* Visual Element */}
          <div className="hero__visual">
            <div className="hero__trading-interface">
              <div className="hero__interface-header">
                <div className="hero__interface-title">CoinVAT Trading Dashboard</div>
                <div className="hero__interface-status">
                  <div className="hero__status-dot"></div>
                  <span>Live Trading</span>
                </div>
              </div>
              
              <div className="hero__interface-content">
                <div className="hero__trading-card">
                  <div className="hero__card-header">
                    <span className="hero__currency">BTC/USD</span>
                    <span className="hero__change positive">+5.2%</span>
                  </div>
                  <div className="hero__price">$67,234.56</div>
                  <div className="hero__chart">
                    <svg viewBox="0 0 200 80" className="hero__chart-svg">
                      <path 
                        d="M 0 60 L 20 55 L 40 45 L 60 40 L 80 35 L 100 30 L 120 25 L 140 20 L 160 15 L 180 10 L 200 5" 
                        stroke="url(#gradient)" 
                        strokeWidth="3" 
                        fill="none"
                      />
                      <defs>
                        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stopColor="#1652F0" />
                          <stop offset="100%" stopColor="#9000FF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
                
                <div className="hero__trading-card">
                  <div className="hero__card-header">
                    <span className="hero__currency">ETH/USD</span>
                    <span className="hero__change positive">+3.8%</span>
                  </div>
                  <div className="hero__price">$3,456.78</div>
                  <div className="hero__chart">
                    <svg viewBox="0 0 200 80" className="hero__chart-svg">
                      <path 
                        d="M 0 70 L 20 65 L 40 55 L 60 45 L 80 40 L 100 35 L 120 30 L 140 25 L 160 20 L 180 15 L 200 10" 
                        stroke="url(#gradient)" 
                        strokeWidth="3" 
                        fill="none"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              
              <div className="hero__interface-footer">
                <div className="hero__ai-indicator">
                  <div className="hero__ai-pulse"></div>
                  <span>AI Bot & Assistant Active</span>
                </div>
                <div className="hero__profit">
                  <span>Today's Profit: </span>
                  <span className="hero__profit-amount">+$2,847.63</span>
                </div>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="hero__floating-element hero__floating-element--1">
              <div className="hero__crypto-symbol">₿</div>
            </div>
            <div className="hero__floating-element hero__floating-element--2">
              <div className="hero__crypto-symbol">Ξ</div>
            </div>
            <div className="hero__floating-element hero__floating-element--3">
              <div className="hero__crypto-symbol">◊</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
